import { cva, type VariantProps } from 'class-variance-authority';
import styles from './input.module.css';

export const inputFieldVariants = cva(styles['input-field-variant'], {
  variants: {
    fieldColumns: {
      twelve: styles['input-field-variant--columns-twelve'],
      nine: styles['input-field-variant--columns-nine'],
      eight: styles['input-field-variant--columns-eight'],
      six: styles['input-field-variant--columns-six'],
      four: styles['input-field-variant--columns-four'],
      three: styles['input-field-variant--columns-three'],
    },
    fieldMaxWidthByChars: {
      twenty: styles['input-field-variant--max-width-by-chars-twenty'],
      ten: styles['input-field-variant--max-width-by-chars-ten'],
      five: styles['input-field-variant--max-width-by-chars-five'],
      four: styles['input-field-variant--max-width-by-chars-four'],
      three: styles['input-field-variant--max-width-by-chars-three'],
      two: styles['input-field-variant--max-width-by-chars-two'],
      one: styles['input-field-variant--max-width-by-chars-one'],
    },
  },
  defaultVariants: {
    fieldColumns: 'twelve',
  },
});

export type InputFieldVariants = VariantProps<typeof inputFieldVariants>;
